(() => {
  if (window.__TMS_FLOATING_BUBBLE_OFFSET__) return;
  window.__TMS_FLOATING_BUBBLE_OFFSET__ = true;

  const MOBILE_MEDIA = window.matchMedia('(max-width: 749px)');
  const STICKY_CART_SELECTOR = '[data-essential-cart-element="container-mobile"]';
  const ALOVE_SELECTOR = '[data-tms-alove-open]';
  const INBOX_SELECTOR = 'shopify-chat';
  const EDGE_GAP = 12;
  const BUBBLE_SIZE = 46;
  const BUBBLE_GAP = 12;

  let frameId = 0;
  let baseAloveBottom = null;

  const setStyleProperty = (element, property, value) => {
    if (!element || element.style.getPropertyValue(property) === value) return;
    element.style.setProperty(property, value);
  };

  const removeStyleProperty = (element, property) => {
    if (!element || !element.style.getPropertyValue(property)) return;
    element.style.removeProperty(property);
  };

  const readBottom = (element) => {
    if (!element) return null;

    const value = Number.parseFloat(window.getComputedStyle(element).bottom);
    if (Number.isFinite(value)) return value;

    const rect = element.getBoundingClientRect();
    return Math.max(0, window.innerHeight - rect.bottom);
  };

  const isVisible = (element) => {
    if (!element) return false;

    const style = window.getComputedStyle(element);
    const rect = element.getBoundingClientRect();

    return (
      style.display !== 'none' &&
      style.visibility !== 'hidden' &&
      Number.parseFloat(style.opacity || '1') > 0.01 &&
      rect.width > 0 &&
      rect.height > 0 &&
      rect.bottom > 0 &&
      rect.top < window.innerHeight
    );
  };

  const resetOffsets = () => {
    const alove = document.querySelector(ALOVE_SELECTOR);
    const inbox = document.querySelector(INBOX_SELECTOR);

    if (alove) {
      removeStyleProperty(alove, '--tms-floating-alove-bottom');
      alove.removeAttribute('data-tms-sticky-cart-offset');
    }

    if (inbox) {
      removeStyleProperty(inbox, '--tms-floating-inbox-shift');
      inbox.removeAttribute('data-tms-sticky-cart-offset');
    }

    document.documentElement.removeAttribute('data-tms-sticky-cart-visible');
    baseAloveBottom = null;
  };

  const updateOffsets = () => {
    frameId = 0;

    if (!MOBILE_MEDIA.matches) {
      resetOffsets();
      return;
    }

    const stickyCart = document.querySelector(STICKY_CART_SELECTOR);
    if (!isVisible(stickyCart)) {
      resetOffsets();
      return;
    }

    const alove = document.querySelector(ALOVE_SELECTOR);
    const inbox = document.querySelector(INBOX_SELECTOR);
    const inboxNudge = inbox?.shadowRoot?.querySelector('.activator-nudge');

    if (!alove && !inboxNudge) return;

    const stickyHeight = Math.ceil(stickyCart.getBoundingClientRect().height);
    const targetLowestBottom = stickyHeight + EDGE_GAP;
    const baseInboxBottom = readBottom(inboxNudge);

    if (alove && baseAloveBottom === null) {
      baseAloveBottom = readBottom(alove);
    }

    const lowestBaseBottom = Math.min(
      baseAloveBottom ?? Number.POSITIVE_INFINITY,
      baseInboxBottom ?? Number.POSITIVE_INFINITY
    );
    const sharedShift = Number.isFinite(lowestBaseBottom)
      ? Math.max(0, targetLowestBottom - lowestBaseBottom)
      : 0;

    const raisedInboxBottom =
      baseInboxBottom === null ? null : baseInboxBottom + sharedShift;
    const raisedAloveBottom =
      baseAloveBottom === null ? null : baseAloveBottom + sharedShift;

    if (inbox && baseInboxBottom !== null && raisedInboxBottom !== null) {
      const inboxShift = raisedInboxBottom - baseInboxBottom;
      setStyleProperty(
        inbox,
        '--tms-floating-inbox-shift',
        `${-inboxShift}px`
      );
      inbox.setAttribute('data-tms-sticky-cart-offset', 'raised');
    }

    if (alove && raisedAloveBottom !== null) {
      const minimumAloveBottom =
        (raisedInboxBottom ?? targetLowestBottom) + BUBBLE_SIZE + BUBBLE_GAP;
      const finalAloveBottom = Math.max(raisedAloveBottom, minimumAloveBottom);

      setStyleProperty(
        alove,
        '--tms-floating-alove-bottom',
        `${Math.ceil(finalAloveBottom)}px`
      );
      alove.setAttribute('data-tms-sticky-cart-offset', 'raised');
    }

    document.documentElement.setAttribute(
      'data-tms-sticky-cart-visible',
      'true'
    );
  };

  const scheduleUpdate = () => {
    if (frameId) return;
    frameId = window.requestAnimationFrame(updateOffsets);
  };

  const observer = new MutationObserver(scheduleUpdate);
  observer.observe(document.body, {
    attributes: true,
    attributeFilter: ['class', 'style'],
    childList: true,
    subtree: true,
  });

  window.addEventListener('scroll', scheduleUpdate, { passive: true });
  window.addEventListener('resize', scheduleUpdate, { passive: true });
  MOBILE_MEDIA.addEventListener?.('change', scheduleUpdate);

  scheduleUpdate();
})();

